import type { SVGAttributes } from 'react';

export function EuskeraIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_516_1205)">
				<circle cx="8" cy="8" r="8" fill="#F0F0F0" />
				<path d="M.07 9.04c.19 1.43.75 2.74 1.59 3.83l4.26-3.83H.07Z" fill="#D80027" />
				<path d="M6.96 15.93V10.09l-3.83 4.26a8 8 0 0 0 3.83 1.58Z" fill="#D80027" />
				<path d="M6.96.07a8 8 0 0 0-3.83 1.58l3.83 4.26V.07Z" fill="#D80027" />
				<path d="M.07 6.96h5.85L1.65 3.13A8 8 0 0 0 .07 6.96Z" fill="#D80027" />
				<path d="M9.04.07v5.84l3.83-4.26A8 8 0 0 0 9.04.07Z" fill="#D80027" />
				<path d="M15.93 6.96a8 8 0 0 0-1.58-3.83l-4.26 3.83h5.84Z" fill="#D80027" />
				<path d="M10.09 9.04l4.26 3.83a8 8 0 0 0 1.58-3.83h-5.84Z" fill="#D80027" />
				<path d="M9.04 15.93a8 8 0 0 0 3.83-1.58l-3.83-4.26v5.84Z" fill="#D80027" />
				<path
					d="M14.35 12.87L9.47 8l4.87-4.87c-.21-.27-.44-.54-.69-.79-.25-.25-.51-.48-.79-.69L8 6.52 3.13 1.65c-.27.21-.54.44-.79.69-.25.25-.48.51-.69.79L6.52 8l-4.87 4.87c.21.27.44.54.69.79.25.25.51.48.79.69L8 9.48l4.87 4.87c.27-.21.54-.44.79-.69.25-.25.48-.51.69-.79Z"
					fill="#496E2D"
				/>
				<path
					d="M9.04 15.93V9.04h6.89c.04-.34.07-.7.07-1.04 0-.35-.02-.7-.07-1.04H9.04V.07a8 8 0 0 0-2.08 0v6.89H.07C.02 7.3 0 7.65 0 8c0 .35.02.7.07 1.04h6.89v6.89a8 8 0 0 0 2.08 0Z"
					fill="#F0F0F0"
				/>
			</g>
			<defs>
				<clipPath id="clip0_516_1205">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
